import { Button } from "@material-ui/core";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  IndeterminateCheckBox,
} from "@material-ui/icons";
import { memo } from "react";

const CheckSituation = ({
  label = "",
  fullWidth,
  checked,
  indeterminate,
  handleCheck,
  disabled,
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      disabled={disabled}
      color={indeterminate ? "secondary" : "primary"}
      onClick={() => handleCheck()}
      style={{ justifyContent: "flex-start" }}
      variant={checked ? "contained" : "outlined"}
      startIcon={
        checked ? (
          <CheckBox />
        ) : indeterminate ? (
          <IndeterminateCheckBox />
        ) : (
          <CheckBoxOutlineBlank />
        )
      }
    >
      {label}
    </Button>
  );
};

export default memo(CheckSituation);
